module.exports = __webpack_public_path__ + "static/banner2.1-92a10e8951e9e21b064dc91aceb1a47c.jpg";